import { HgSupportedLanguage } from '@smg-real-estate/domus';

export enum GTMPageFeatureId {
  INITIAL_PAGE_LOAD = 'p000',
  DETAIL_PAGE = 'p001',
  DETAIL_PAGE_AD_NOT_FOUND = 'p002',
  RESULT_LIST_PAGE = 'p004',
  LANGUAGE_SWITCH = 'p005',
  PREVIEW_PAGE_LOAD = 'p013b',
  AGENCY_PROFILE_OPENED = 'p017',
  RECOMMENDATION_LIST_LOADED = 'e005',
  RECOMMENDATION_LIST_ITEM_CLICKED = 'e006',
  RECOMMENDATION_LIST_CHANGED = 'e008',
  RESULT_LIST_ITEM_CLICK = 'e009',
  OUTBOUND_LINK_CLICKED = 'e010',
  SEARCH_SORT = 'e012',
  SHARE_BUTTON_CLICKED = 'e016',
  SHARING_OPTION_CLICKED = 'e017',
  EXPERIMENT_INITIALIZED = 'e018',
  DETAIL_PAGE_PARTNER_LINK_CLICKED = 'e022',
  UNDO_ACTION = 'e026',
  PDP_INTERACTION = 'e028',
  MAP_INTERACTION = 'e043',
  MAP_PIN_CLICKED = 'e038',
  REPORT_SUBMIT = 'e032',
  CTA_CLICK = 'e049',
  PARTNER_WIDGET = 'e051',
  PARTNER_SERVICE = 'e052',
  AGENCY_PROFILE_PAGE_INTERACTION = 'e057',
}

export enum GTMPageType {
  DETAIL_PAGE = 'pdp',
  PAGE_NOT_FOUND = 'err',
  RESULT_LIST_PAGE = 'srp',
  AGENCY_PROFILE = 'agencyProfile',
  PREVIEW_PAGE = 'previewListing',
  INSERT_LISTING = 'insertListing',
}

export enum GTMAgencyProfilePageSubType {
  PREMIUM_PROFILE_PAGE = 'main_premium',
  BASIC_PROFILE_PAGE = 'main_basic',
  PREMIUM_AGENCY_SRP = 'srp_premium',
  BASIC_AGENCY_SRP = 'srp_basic',
}

export enum InteractionEvent {
  AUTHENTICATION = 'authentication',
  LOAD = 'load',
  LIST_LOAD = 'list_load',
  LIST_CLICK_THROUGH = 'list_clickthrough',
  LIST_CHANGE = 'list_change',
  OUTBOUND_LINK = 'link_outbound',
  SHARE_OPEN = 'share_open',
  SHARE_ACTION = 'share_action',
  PARTNER_LINK = 'partner_link_click',
  UNDO = 'undo',
  SUBMIT_SEARCH = 'submit_search',
  SEARCH_CLICKTROUGH = 'search_clickthrough',
  SEARCH_MAP_TOGGLE = 'search_map_toggle',
  SEARCH_PIN_CLICK = 'search_pin_click',
  PDP_INTERACTION = 'pdp_interaction',
  SRP_INTERACTION = 'srp_interaction',
  BUTTON_CLICK = 'button_click',
  MAP_INTERACTION = 'map_interaction',
  FEATURE_DISPLAYED = 'feature_displayed',
  NON_INTERACTION = 'non_interaction',
  CTA_CLICK = 'cta_click',
  AGENCY_PROFILE_INTERACTION = 'agency_profile_interaction',
  SRP_SLIDER_CLICK = 'srp_slider_click',
  GENERIC_LINK_CLICK = 'generic_link_click',
  GENERIC_INTERACTION = 'generic_interaction',
  FOOTER_INTERACTION = 'footer_interaction',
  OPEN_SHARE = 'open_share',
  SUBMIT_FORM_LEAD = 'submit_formlead',
  FORM_SYSTEM_FEEDBACK_LEAD = 'formSystemFeedback_lead-email',
  SUBMIT_FORM_LEAD_ERROR = 'submit_formlead_error',
  SUBMIT_CALLED = 'submit_calllead',
  LIST_LOAD_RECOMMENDATION = 'list_load_recommendation',
  VIRTUAL_PAGEVIEW = 'virtual_pageview',
  SERVICE_BOX_INTERACTION = 'servicebox_interaction',
  SAVE_SEARCH = 'save_search',
  SEARCH_SAVE_SUCCESS = 'search_save_success',
  LIST_LOAD_EXTENDED_SEARCH = 'list_load_extended_search',
  EXPERIMENT_IMPRESSION = 'experiment_impression',
  SAVE_SEARCH_TRY = 'save_search_try',
  SEARCH_SAVE_BUTTON = 'search_save_button',
  SEARCH_BAR_INTERACTION = 'search_bar_interaction',
  HIDE_LISTING_INTERACTION = 'hide_listing_interaction',
}

export enum InteractionContainerName {
  ADDRESS_BOX = 'addressBox',
  CONTACT_FORM = 'contactForm',
  LISTER_CONTACT_PHONE = 'listerContactPhone',
  VIEWING_CONTACT_PHONE = 'viewingContactPhone',
  SHARE = 'share',
  PDP_CONTENT = 'pdp-content',
  PDP_LEAD_MODAL = 'pdp-lead-modal',
  SEARCH_RESULTS_LIST = 'searchResultsList',
  SEARCH_BAR = 'search_bar',
  DETAIL_PAGE_CONTENT = 'detailPageContent',
  HEADER = 'header',
  TOGGLE = 'toggle',
  MAP = 'map',
  REPORT_BOX = 'reportBox',
  LISTING_ACCESSORIES_LINKS = 'listingAccessoriesLinks',
  OPEN = 'open',
  CLOSE = 'close',
  LISTINGS = 'listings',
  INFO_ICON = 'infoIcon',
  LINK = 'link',
  LOGO = 'logo',
  WIDGET = 'widget',
  IN_MODAL = 'inModal',
  ALERT_ACTIVATION = 'alertActivation',
  CALL_TO_ACTION = 'cta',
  GGA_MAUR = 'ggaMaur',
  HOUSEHOLD_INSURANCE_MOBILIAR = 'household_insurance_mobiliar',
  PDP = 'pdp',
  SRP = 'srp',
}

export enum InteractionContainerDetail {
  CAROUSEL = 'carousel',
  LISTING_ACCESSORIES_PROJECT_LINK = 'listingAccessoriesProjectLink',
  LIST = 'list',
  PROJECT_IMAGE_TEASER = 'projectImageTeaser',
  MORTGAGE_COMPARISON_TOOL = 'inPage',
  MORTGAGE_COMPARISON_TOOL_MODAL = 'inLightbox',
  TEXT = 'text',
  SYMBOL = 'symbol',
  SYMBOL_AND_TEXT = 'symbolAndText',
  NOTIFICATION = 'notification',
  BUTTON = 'button',
  REPORT_CHOSE_SUSPECT = 'suspectedFraud',
  REPORT_CHOSE_LOCATION = 'incorrectLocation',
  REPORT_CHOSE_OTHER = 'otherReason',
  PIN = 'pin',
  DROPDOWN = 'dropdown',
  IN_MODAL = 'inModal',
  IN_WIDGET = 'inWidget',
  PW_SHOWN_MP = 'MP',
  AFFORDABILITY_CALCULATOR = 'affordabilityCalculator',
  SCHEDULE_APPOINTMENT = 'scheduleAppointment',
  AGENCY_PHONE = 'agencyPhone',
  AGENCY_PHONE_OVERVIEW_BUTTON = 'agencyPhone_overviewButton',
  BOTTOM_SHEET = 'bottomSheet',
  INTERNET_PROVIDER = 'internetProvider',
  HOUSEHOLD_INSURANCE = 'householdInsurance',
  TENANT_PLUS = 'tenantPlus',
  BUY_OR_RENT = 'buy|rent',
  RENT = 'rent',
  BUY = 'buy',
  AGENCY_PHONE_TEAM_PROFILE = 'agencyPhone_teamProfile',
  CONTACT_FORM_AFTER_SUBMIT = 'after_submit_contact_form',
  REVISIT_CONTACTED_PDP = 'revisit_contacted_pdp',
  POLYGON = 'polygon',
  SEND_MESSAGE = 'send_message',
  ADDITIONAL_INFORMATION_SUBMIT = 'additional_information_submit',
}

export enum InteractionGoal {
  SEND_MESSAGE = 'sendMessage',
  REVEAL_NUMBER_AGENCY = 'revealNumberAgency',
  REVEAL_NUMBER_LISTER = 'revealNumberLister',
  REVEAL_NUMBER_VIEWING = 'revealNumberViewing',
  CALL_AGENCY = 'callAgency',
  CALL_LISTER = 'callLister',
  CALL_VIEWING = 'callViewing',
  LISTING_OUTBOUND_LINK = 'listing_outbound-link',
  REQUEST_ADDRESS = 'requestAddress',
  SHARE_EMAILTO = 'share_emailTo',
  SHARE_LINKCOPY = 'share_linkCopy',
  SHARE_SEE_OPTIONS = 'share_seeOptions',
  SHARE_WHATSAPP = 'share_whatsapp',
  LOCATION_DEMOGRAPHY_TAXES_OVERVIEW = 'locationDemographyTaxesOverview',
  MOVING_CLEANING_QUOTES = 'movingCleaningQuotes',
  MARKET_VALUE_LOCATION_CHECK = 'marketValueLocationCheck',
  MORTGAGE_COMPARISON_TOOL = 'mortgageComparisonTool',
  RENTAL_DEPOSIT_ALTERNATIVE = 'rentalDepositAlternative',
  RENTAL_PROVISIONAL_CERT = 'rental_provisional_cert',
  RENTAL_PROVISIONAL_CERT_SWISSCAUTION = 'rental_provisional_cert_swisscaution',
  ORDER_DEBT_COLLECTION_REGISTER = 'orderDebtCollectionRegister',
  AXA_INSURANCE_REGISTER = 'householdInsuranceCalculator',
  HOUSEHOLD_INSURANCE_COMPARISON = 'household_insurance_comparison',
  NEW_CONSTRUCTION_PROJECT_WEBSITE = 'newConstructionProjectWebsite',
  GO_TO_PDP = 'goToPDP',
  TOGGLE_MAP = 'toggleMap',
  OPEN_PDP_OVERLAY = 'openPdpOverlay',
  MAP_DETAILS = 'mapDetails',
  CHOOSE_MAP_TYPE = 'chooseMapType',
  SELECT_FEATURE = 'selectFeature',
  DESELECT_FEATURE = 'deselectFeature',
  RECOMMENDATIONS_SHOW_MORE_ITEMS = 'showMoreItems',
  MORTGAGE_CALCULATOR_LITE = 'mortgageCalculatorLite',
  REPORT_LISTING = 'reportListing',
  SEND_REPORT = 'sendFraudReport',
  GO_TO_VIDEO = 'goToVideo',
  GO_TO_VIRTUAL_TOUR = 'goToVirtualTour',
  GO_TO_DOCUMENT = 'goToDocument',
  CHANGE_SEARCH = 'changeSearch',
  PRE_QUALIFY_MP = 'preQualificationMP',
  PRE_QUALIFY_UBS = 'preQualificationUBS',
  OPEN_PRE_QUALIFY_MP = 'openPreQualificationMP',
  OPEN_PRE_QUALIFY_UBS = 'openPreQualificationUBS',
  RETURN_FROM_MP = 'returnFromMP',
  AFFORDABILITY_CALCULATOR = 'affordabilityCalculator',
  OPEN_AFFORDABILITY_CALCULATOR = 'openAffordabilityCalculator',
  DISPLAY_FEATURE = 'displayFeature',
  DISPLAY_INTERNET_PROVIDER_CONTENT = 'unfoldInetProvider',
  INTERNET_PROVIDER = 'internetProvider',
  GO_TO_AGENCY_PROFILE = 'goToAgencyProfile',
  OPEN_DETAILS = 'openDetails',
  SCHEDULE_APPOINTMENT = 'scheduleAppointment',
  LEARN_MORE = 'learnMore',
  SUBMIT_FORM = 'submitForm',
  GO_TO_NEXT_STEP = 'goToNextStep',
  REPORT_ADDRESS_CHANGE = 'reportAddressChange',
  GO_TO_LOGIN = 'goToLogin',
  REGISTER_ACCOUNT = 'register_account',
  DISPLAY_LOGIN_REQUEST = 'display_login_request',
  CLOSE_MODAL = 'closeModal',
  SIGN_UP_TENANT_PLUS = 'signUpTenantPlus',
  REVEAL_NUMBER = 'revealNumber',
  SHOW_ALL_OBJECTS = 'showAllObjects',
  OPEN_TENANT_PLUS_MODAL = 'tenantPlusModal',
  SEND_MESSAGE_OK = 'sendMessage_ok',
  SEND_MESSAGE_ERROR = 'sendMessage_error',
  CTA_CLICK_LEAD_CALL = 'ctaClick_lead-call',
  LIST_CLICKTHROUGH_RECOMMENDATION = 'list_clickthrough_recommendation',
  LIST_CHANGE_RECOMMENDATION = 'list_change_recommendation',
  OPEN_PRINT = 'openPrint',
  OPEN_ADVERTISED_AGENCY_WEBSITE = 'openAdvertisersWebsite',
  GO_TO_PARTNER_SITE = 'goToPartnerSite',
  FINANCIAL_CONSULTATION = 'financialConsultation',
  COMPARE_LIVING_COSTS = 'compareLivingCosts',
  OPEN_TIPS_AND_SERVICES = 'openTipsAndServices',
  PARTNER_INTEGRATION = 'partner_integration',
  LOAD_SERVICE_BOX = 'load_service_box',
  CLICK_OTHER_OBJECTS_IN_PROJECT = 'click_other_objects_in_project',
  GO_TO_OTHER_OBJECTS_IN_PROJECT = 'go_to_other_objects_in_project',
  OPEN_CONTACT_FORM_AGAIN = 'open_contact_form_again',
  CONTACT_AGENCY = 'contact_agency',
  AGENCY_MAP_FILTER = 'agency_map_filter',
  CREATE_ACCOUNT = 'create_account',
  CLOSE_LOGIN_MODAL = 'close_login_modal',
  DISPLAY_LOGIN_MODAL = 'display_login_modal',
  DISPLAY_SEARCH_ALERT_MODAL = 'display_search_alert_modal',
  CREATE_SEARCH_SUBSCRIPTION = 'createSearchSubscription',
  OPEN_DROPDOWN = 'open_dropdown',
  OPEN_TOOLTIP = 'openTooltip',
  INPUT_LEAD_QUALIFICATION_INFO = 'input_lead_qualification_info',
  SELECT_SEARCH_QUICK_FILTER = 'select_search_quick_filter',
  CREATE_PROFILE = 'create_profile',
  EDIT_POI = 'edit_poi',
  DISPLAY_POI_MODAL = 'display_poi_modal',
  CLOSE_POI_MODAL = 'close_poi_modal',
  CREATE_POI = 'create_poi',
  DELETE_POI = 'delete_poi',
  GO_TO_COMMERCIAL_RE = 'go_to_commercial_RE',
  SAVE_SEARCH = 'saveSearch',
  DISPLAY_BLURRY_IMAGE = 'display_blur_image',
  VIEW_BLUR_IMAGE = 'view_blur_image',
  SELECT_PROPERTY_TYPE = 'selectPropertyType',
  HIDE_LISTING_TRY = 'hide_listing_try',
  HIDE_LISTING_SUCCESS = 'hide_listing_success',
  UNHIDE_LISTING = 'unhide_listing',
}

export enum InteractionElement {
  BUTTON = 'button',
  SECONDARY_BUTTON = 'secondaryButton',
  LINK = 'link',
  SLIDER_CHANGE_PREVIOUS = 'arrowLeft',
  SLIDER_CHANGE_NEXT = 'arrowRight',
  MODAL_BUTTON = 'modalButton',
  TO_LIST = 'toList',
  MAP_PIN = 'map_pin',
  TO_MAP = 'toMap',
  WIDGET = 'widget',
  CTA_BUTTON = 'ctaButton',
  MODAL = 'modal',
  FORM_SUBMIT_BUTTON = 'formSubmitButton',
}

export enum MapListingsLayerStatus {
  LISTINGS_ON = 'listings-on',
  LISTINGS_OFF = 'listings-off',
}

export enum EventLabel {
  TENANTPLUS_TRIAL_CRIF_FROM_PDP_BOTTOMSHEET = 'tenantPlus_trial_crif_pdp_bottomSheet',
  TENANT_PLUS_CRIF_LANDING_PAGE = 'TENANT_PLUS_CRIF_LANDING_PAGE',
  SEARCH_ALERTS = 'search_alerts',
  SUCCESS = 'success',
  SUCCESSFUL = 'successful',
  POI_SRP = 'poi_srp',
  POI_SRP_PUBLIC_TRANSPORT = 'poi_srp_public',
  POI_SRP_WALKING = 'poi_srp_walk',
  POI_SRP_CYCLING = 'poi_srp_bike',
  POI_SRP_DRIVING = 'poi_srp_car',
  POI_PDP = 'poi_pdp',
  POI_PDP_PUBLIC_TRANSPORT = 'poi_pdp_public',
  POI_PDP_WALKING = 'poi_pdp_walk',
  POI_PDP_CYCLING = 'poi_pdp_bike',
  POI_PDP_DRIVING = 'poi_pdp_car',
  BANNER = 'banner',
  STICKY_BUTTON = 'stickyButton',
  VIEW_BLURRY_IMAGE_SRP = 'tenantPlus_trial_blur_image_srp',
}

export type TrackingParameterValue =
  | string
  | string[]
  | number[]
  | number
  | boolean
  | undefined
  | InteractionContainerName
  | InteractionContainerDetail
  | InteractionEvent
  | InteractionGoal
  | InteractionElement
  | MapListingsLayerStatus;

export interface GTMPageViewTrackingParameters {
  page_type: GTMPageType;
  h_web_feature_id_019: GTMPageFeatureId;
  page_contentLanguage: HgSupportedLanguage;
  page_normalizedUrl?: string;
  page_realUrl: string;

  [additionalParameters: string]: TrackingParameterValue;
}

export enum TrackingFormattedListingType {
  BASIC = 'basic',
  PREMIUM = 'premium',
  STANDARD = 'std',
  TOP = 'top',
  TENANT_PLUS = 'tenantPlus',
}

export type HarmonizedTrackingKeys =
  | 'h_event_category_006'
  | 'h_event_action_007'
  | 'h_event_label_008'
  | 'h_login_location_049'
  | 'h_is_tenant_plus_us_017'
  | 'h_target_page_title_026'
  | 'h_target_url_029'
  | 'h_client_login_provider_034'
  | 'h_login_status_035'
  | 'h_login_user_id_036'
  | 'h_client_login_user_id_036'
  | 'h_login_user_type_037'
  | 'h_client_login_user_type_037'
  | 'h_map_type_045'
  | 'h_map_zoom_level_241'
  | 'h_map_layer_044'
  | 'h_interaction_containername_052'
  | 'h_interaction_element_055'
  | 'h_lead_id_066'
  | 'h_search_filter_floortype_068'
  | 'h_search_filter_available_from_069'
  | 'h_share_id_070'
  | 'h_search_source_072'
  | 'h_search_sorted_details_073'
  | 'h_search_filter_category_075'
  | 'h_srp_items_loaded_078'
  | 'h_srp_items_vas_displayed_079'
  | 'h_search_term_input_081'
  | 'h_search_filter_082'
  | 'h_search_offer_type_083'
  | 'h_list_item_clicked_id_085'
  | 'h_list_name_086'
  | 'h_list_items_all_087'
  | 'h_list_items_loaded_088'
  | 'h_list_items_vas_089'
  | 'h_list_item_vas_090'
  | 'h_experiment_split_treatments_107'
  | 'h_listing_package_name_108'
  | 'h_page_type_110'
  | 'h_page_subtype_112'
  | 'h_list_type_111'
  | 'h_content_language_116'
  | 'h_listing_offer_type_117'
  | 'h_listing_categories_hgrets_118'
  | 'h_listing_advertisement_id_120'
  | 'h_listing_object_ref_id_123'
  | 'h_listing_layout_124'
  | 'h_listing_sorting_score_126'
  | 'h_model_algo_142'
  | 'h_listing_geo_zip_152'
  | 'h_listing_lister_id_154'
  | 'h_listing_picture_count_155'
  | 'h_listing_vas_156'
  | 'h_listing_geo_canton_157'
  | 'h_listing_geo_country_158'
  | 'h_listing_project_id_159'
  | 'h_is_tenant_plus_user_166'
  | 'h_search_alert_package_172'
  | 'h_number_of_search_terms_entered_278'
  | 'h_search_results_loaded_279'
  | 'h_search_results_total_280'
  | 'h_search_vas_displayed_282'
  | 'h_position_on_list_overall_283'
  | 'h_list_items_total_284'
  | 'h_list_items_loaded_285'
  | 'h_search_results_pages_all_287'
  | 'h_search_results_page_current_288'
  | 'h_search_results_page_size_289'
  | 'h_listing_price_gross_303'
  | 'h_sf_price_from_340'
  | 'h_sf_price_to_341'
  | 'h_sf_rooms_from_342'
  | 'h_sf_rooms_to_343'
  | 'h_sf_livingspace_from_344'
  | 'h_sf_livingspace_to_345'
  | 'h_sf_lotsizefrom_346'
  | 'h_sf_lotsizeto_347'
  | 'h_sf_floorspace_from_348'
  | 'h_sf_floorspace_to_349'
  | 'h_sf_cubature_from_350'
  | 'h_sf_cubature_to_351'
  | 'h_sf_buildyear_from_352'
  | 'h_sf_buildyear_to_353'
  | 'h_sf_radius_354'
  | 'h_sf_facilities_isfamilyfriendly_355'
  | 'h_sf_facilities_hasbalconyorpatio_356'
  | 'h_sf_facilities_petsallowed_357'
  | 'h_sf_facilities_isminergie_358'
  | 'h_sf_facilities_haselevator_359'
  | 'h_sf_facilities_haswheelchairsaccess_360'
  | 'h_sf_facilities_isnewbuilding_361'
  | 'h_sf_only_with_price_362'
  | 'h_sf_facilities_hasparking_363'
  | 'h_sf_facilities_isoldbuilding_364'
  | 'h_sf_facilities_haspool_365'
  | 'h_lead_offer_sale_138'
  | 'h_extra_information_144'
  | 'h_features_displayed_171'
  | 'h_listing_completeness_score_127'
  | 'h_list_item_agency_pic_176'
  | 'h_srp_items_agency_pic_177'
  | 'h_search_agency_pic_loaded_178'
  | 'h_share_user_profile_145'
  | 'h_subscription_id_searchalert_030'
  | 'h_experiment_variant_array_048';

type OneOrUndefined = 1 | undefined;

export interface SearchQueryMetaDataHarmonized {
  h_search_term_geo_080?: string;
  h_number_of_search_terms_entered_278?: number;
  h_search_offer_type_083?: 'buy' | 'rent' | '';
  h_search_filter_category_075?: string;
  h_search_filter_category_sub_084?: string;
  h_search_filter_082?: string;
  h_sf_price_from_340?: number;
  h_sf_price_to_341?: number;
  h_sf_rooms_from_342?: number;
  h_sf_rooms_to_343?: number;
  h_sf_radius_354?: number;
  h_sf_livingspace_from_344?: number;
  h_sf_livingspace_to_345?: number;
  h_sf_lotsizefrom_346?: number;
  h_sf_lotsizeto_347?: number;
  h_search_filter_floortype_068?: 'ground_floor' | 'not_ground_floor';
  h_search_filter_available_from_069?: string;
  h_search_sorted_details_073?: string;
  h_sf_floorspace_from_348?: number;
  h_sf_floorspace_to_349?: number;
  h_sf_cubature_from_350?: number;
  h_sf_cubature_to_351?: number;
  h_sf_buildyear_from_352?: number;
  h_sf_buildyear_to_353?: number;
  h_sf_only_with_price_362?: OneOrUndefined;
  h_sf_facilities_isfamilyfriendly_355?: OneOrUndefined;
  h_sf_facilities_hasbalconyorpatio_356?: OneOrUndefined;
  h_sf_facilities_petsallowed_357?: OneOrUndefined;
  h_sf_facilities_isminergie_358?: OneOrUndefined;
  h_sf_facilities_haselevator_359?: OneOrUndefined;
  h_sf_facilities_haswheelchairsaccess_360?: OneOrUndefined;
  h_sf_facilities_isnewbuilding_361?: OneOrUndefined;
  h_sf_facilities_isoldbuilding_364?: OneOrUndefined;
  h_sf_facilities_hasparking_363?: OneOrUndefined;
  h_sf_facilities_haspool_365?: OneOrUndefined;
  h_context_060?: string;
  h_web_feature_id_019?: GTMPageFeatureId;
  search_click_positionOverall?: number;
  search_click_positionOnPage?: number;
  search_click_listingId?: string;
  search_click_valueAddedServices?: TrackingFormattedListingType;
  interaction_goal?: string;
}

export enum ListName {
  EXTENDED_SEARCH_BY_RADIUS_10km = 'extended_search_by_radius_10km',
  EXTENDED_SEARCH_BY_RADIUS_20km = 'extended_search_by_radius_20km',
  EXTENDED_SEARCH_BY_PRICE_500CHF = 'extended_search_by_price_500chf',
}

export type HarmonizedTracking = Partial<Record<HarmonizedTrackingKeys, TrackingParameterValue>> &
  SearchQueryMetaDataHarmonized;
